const BASE_URL = {
    PROD: 'https://us-central1-merit-werb.cloudfunctions.net/api',
    EMULATOR: 'http://localhost:5001/merit-werb/us-central1/api',
};

export default BASE_URL;
